import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import { Form, Input } from '~/components/Form';
import { t } from '~/helpers';
import {
  storeData,
  updateData,
} from '~/store/modules/operacaoLimpezaDvec/actions';

export default function CreateOrUpdate({ reference, data, create }) {
  const dispatch = useDispatch();

  const { client, id } = useSelector((state) => state.user.profile);
  const { loading, find, params } = useSelector(
    (state) => state.operacaoLimpezaDvec
  );

  const initials = create
    ? data
    : {
        ...find,
        ...data,
        iddvecveiculo: isEmpty(find) ? '' : find.iddvecveiculo,
      };

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        observacaohistoricodvec: Yup.string().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {
        idhistoricodvec: 0,
        idcliente: client,
        tipohistoricodvec: 1,
        datahorahistoricodvec: null,
        idveiculo: initials.idveiculo,
        idempresaveiculo: initials.idempresaveiculo,
        iddvechistoricodvec: initials.iddvecveiculo,
        idusuario: id,
        observacaohistoricodvec: param.observacaohistoricodvec,
      };

      dispatch(updateData(objSend, params));
      // setDvec(false);
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    if (!loading) {
      reference.current.setData(initials);
    }
  }, [loading, initials]);

  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
          <Input
            disabled
            name="idveiculo"
            label={t('s.operacao.limpezatag.idveiculo')}
          />

          <Input
            disabled
            name="placaveiculo"
            label={t('s.operacao.limpezatag.placaveiculo')}
          />

          <Input
            disabled
            name="iddvecveiculo"
            label={t('s.operacao.limpezadvec.iddvechistoricodvec')}
          />

          <Input
            multiline
            name="observacaohistoricodvec"
            label={t('s.operacao.limpezatag.observacaohistoricotag')}
            rows={4}
          />
        </Form>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
